module.exports = __webpack_public_path__ + "img/retrospect-process-2.efef3145.jpg";